<template>
    <div>
        <el-breadcrumb separator="/" class="bread">
            <!--<el-breadcrumb-item :to="{ name: 'index' }">首页</el-breadcrumb-item>-->
            <el-breadcrumb-item>商品分组</el-breadcrumb-item>
        </el-breadcrumb>

        <el-form :inline="true" :model="topForm" ref="topForm">
            <el-form-item>
                <el-button type="primary" @click="add()" icon="search" >创建商品分组</el-button>
            </el-form-item><br/>
            <el-select class="m-1" v-model="topForm.kioskNo" placeholder="机器编号" @change="getfindData()">
                <el-option label="全部售货机" value="">全部售货机</el-option>
                <el-option label="K1-A112" value="K1-A112" v-show="this.getcookie('storeId')=='store001'">K1-A112</el-option>
                <el-option label="K1-A113" value="K1-A113" v-show="this.getcookie('storeId')=='store001'">K1-A113</el-option>
                <el-option label="X2-A179" value="X2-A179" v-show="this.getcookie('storeId')=='0001'">X2-A179</el-option>
                <el-option label="X2-A173" value="X2-A173" v-show="this.getcookie('storeId')=='0001'">X2-A173</el-option>
            </el-select>


            <el-form-item  class="m-1" style="margin-left: 20px;">
                <el-input v-model="topForm.groupName" placeholder="查询商品分组名称" ></el-input>
            </el-form-item>


            <el-form-item>
                <el-button type="primary" class="" @click="getfindData()" icon="search":loading="loading">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="groupForm('topForm')">重置</el-button>
            </el-form-item>
        </el-form>


        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="groupName" label="商品分组名称"></el-table-column>
            <el-table-column prop="kioskNo" label="售货机ID"></el-table-column>
            <el-table-column prop="count" label="商品个数"></el-table-column>
            <el-table-column prop="updateTime" label="创建时间" :formatter="startformatter">  </el-table-column>
            <el-table-column label="操作">
                <template scope="scope" >
                    <el-button type="primary" @click="modify(scope.row)"  size="small" >编辑</el-button>
                    <el-button type="danger"  size="small" @click="delGroup(scope.row)">删除</el-button>
                    <el-button   size="small"  @click="copyGroup(scope.row,1)">复制</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="block">
            <el-pagination
                    @current-change="handleCurrentChange"
                    @size-chahange="handleSizeChange"
                    :current-page="currentpage"
                    :page-count="pagesCount"
                    :page-sizes="pagesizes"
                    :page-size="pagesize"
                    :total="pagesCount"
                    layout=" total, prev, pager, next, jumper"
            >
            </el-pagination>
        </div>
    </div>

</template>

<script>
    import moment  from 'moment'
    export default {
        data() {
            return {
                //页眉设置参数
                currentpage: 1,//当前页数默认是1
                pagesCount: 0, //总数默认0
                pagesizes: [10, 20, 30],//条数列
                pagesize: 10,//行数
                activeNum: 0, //默认起始行数
                endNum: 10,//默认结束行数
                loading:false,
                copyFlag:false,
                url:this.productURL+"/vueFeign/findGroup",
                saveurl:this.productURL+"/vueFeign/saveGroup",
                tableData: [],
                groupListData: [],
                topForm:{
                    kioskNo:'',
                    groupName:''
                }
            }
        },
        created(){
            this.getData();
        },
        methods:{
            handleSizeChange(val){
                console.log(`每页 ${val} 条`);
                this.pagesize=val
                this.activeNum=(val*this.currentpage)-val;
                this.endNum=(val*this.currentpage)
                this.getData();
                //数目变更
            },
            handleCurrentChange(val){
                this.currentpage=val;
                this.activeNum=(this.pagesize*val)-this.pagesize
                this.endNum=(this.pagesize*val)
                this.getData();
            },
            getfindData(){
                this.currentpage = 1;
                this.activeNum=0;
                this.getData();
            },
            getData(){
                //数据请求
                this.loading = true
                var params = {active:this.activeNum,len:this.pagesize,kioskNo:this.topForm.kioskNo,groupName:this.topForm.groupName,tenantId:this.getcookie('storeId')};
                //异步请求
                this.$http.post(this.url,params)
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.Code=='200'){
                                this.tableData = response.body.Data
                                this.pagesCount = response.body.Count.length;
                            }else if(response.body.code=='500'){
                                this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                            }
                        }
                        this.loading = false;
                    },function(response){
                        this.loading = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            copyGroup(row,num){
                var name = row.groupName+"("+num+")";
                var params = {tenantId:this.getcookie('storeId'),groupName:name};
                //异步请求
                this.$http.get(this.productURL+"/vueFeign/verifyGroupName",{params:params})
                    .then(response => {
                        if (response.status == 200) {
                            if (response.body.Code == '500') {
                                this.$message({showClose: true, message: response.body.Meta, type: 'error'});
                            } else {
                                if(response.body.Data.length > 0){
                                    this.copyGroup(row,num+1);
                                }else {
                                    this.verifyGroupName(row,name);

                                }
                            }
                        }
                    });

            },
            proGroupList(groupId,copyId){
                //数据请求
                var params = {groupId: groupId,proName:''};
                //异步请求
                this.$http.post(this.productURL + "/vueFeign/findProGroup", params)
                    .then(response => {
                        if (response.status === 200) {
                            if (response.body.Code == '200') {
                                this.groupListData = response.body.Data.groupList;
                                this.addProGroup(copyId);
                            }
                        }
                    }, function (response) {
                        this.loading = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            verifyGroupName(row,name){
                //数据请求
                var params = {groupName:name,kioskNo:row.kioskNo,tenantId:this.getcookie('storeId'),
                    firstPriority:row.firstPriority,secondPriority:row.secondPriority};
                //异步请求
                this.$http.post(this.saveurl,params)
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.Code=='200'){
                                this.proGroupList(row.groupId,response.body.Data.groupId);

                                this.$message({ showClose: true, message: "复制成功",  type: 'success' });

                            }else if(response.body.code=='500'){
                                this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                            }
                        }
                        this.getData();
                    },function(response){
                        this.loading = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            addProGroup(groupId) {
                for (var i = 0; i < this.groupListData.length; i++) {
                    var SKU = this.groupListData[i].SKU;
                    //数据请求
                    var params = {groupId: groupId, SKU: SKU, sequenceNum: '0'};
                    //异步请求
                    this.$http.post(this.productURL + "/vueFeign/saveProGroup", params)
                        .then(response => {
                            if (response.status === 200) {
                                if (response.body.Code == '200') {
                                    this.getfindData();
                                } else if (response.body.code == '500') {
                                    this.$message({showClose: true, message: response.body.msg, type: 'error'});
                                }
                            }
                        }, function (response) {
                            this.loading = false;
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        })
                }
            },
            delGroup(row){
                this.$confirm('你确定要删除这条数据么？删除是不可恢复的', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //数据请求
                    var params = {groupId:row.groupId};
                    //异步请求
                    this.$http.post(this.productURL+"/vueFeign/delGroup",params)
                        .then(response => {
                            if (response.status === 200) {
                                if(response.body.Code=='200'){
                                    this.$message({ showClose: true, message: "删除成功",  type: 'success' });
                                }else if(response.body.code=='500'){
                                    this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                                }
                            }
                            this.getData();
                        },function(response){
                            this.loading = false;
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        })
                })
            },
            groupForm(formName) {
                this.topForm.groupName='';
                this.getData();
            },
            startformatter(row, column) {
                console.log()
                var d = new Date(row.updateTime.time)
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },
            add(){
                this.$router.push( {path:"groupAdd"});
            },
            modify(row){
                this.$router.push( {path:"groupModify",query:{groupId:row.groupId,groupName:row.groupName,
                    firstPriority:row.firstPriority,secondPriority:row.secondPriority,kioskNo:row.kioskNo}});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// groupManager.vue?9eeb2d08